import { render, staticRenderFns } from "./ataraxia.vue?vue&type=template&id=3676358b&scoped=true"
import script from "./ataraxia.vue?vue&type=script&lang=js"
export * from "./ataraxia.vue?vue&type=script&lang=js"
import style0 from "./ataraxia.vue?vue&type=style&index=0&id=3676358b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676358b",
  null
  
)

export default component.exports